// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"341":"a3a9cc9930acdfa3","472":"8a187b90a4661754"}[chunkId] + ".js";
};